import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RemoveTextStyleIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RemoveTextStyle",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.44 2H7.51c-1.02 0-1.85.83-1.85 1.85S6.49 5.7 7.51 5.7h4.1L8.49 18.19a1.857 1.857 0 0 0 1.33 2.23h.01q.21.06.45.06c.86 0 1.59-.59 1.79-1.39L15.41 5.7h5.02c1.02 0 1.85-.83 1.85-1.85S21.45 2 20.43 2Zm-6.77 21.24H6.28c-.51 0-.92.41-.92.92s.41.92.92.92h7.39c.51 0 .92-.41.92-.92s-.41-.92-.92-.92m8.93.76 3.64-3.64c.25-.25.4-.6.4-.98s-.15-.73-.4-.98-.6-.41-.98-.41-.73.16-.98.41l-3.64 3.64L17 18.4c-.25-.23-.58-.37-.94-.37-.76 0-1.39.62-1.39 1.39 0 .37.14.7.37.94S18.68 24 18.68 24l-3.64 3.64c-.25.25-.41.6-.41.98 0 .76.62 1.38 1.38 1.39.38 0 .73-.16.98-.41l3.64-3.64 3.64 3.64c.25.25.59.41.98.41a1.385 1.385 0 0 0 .97-2.37L22.58 24Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.43 4.14H7.58a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28ZM15.58 25.86H4a1.14 1.14 0 1 1 0-2.28h11.58a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.72 21.29a1.145 1.145 0 0 1-1.11-1.44l4.6-17.15c.16-.61.79-.97 1.4-.81s.97.79.81 1.4l-4.59 17.14c-.14.51-.6.85-1.1.85ZM20.15 29.29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l6.86-6.86a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.01 29.29c-.29 0-.58-.11-.81-.33l-6.86-6.86a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l6.86 6.86a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};
RemoveTextStyleIcon.displayName = 'RemoveTextStyleIcon';